
import { defineComponent } from "vue";
import validators from "@/utils/validators";

type ComponentData = {
  value?: number;
  validation_message?: string;
};

export default defineComponent({
  name: "NumberField",
  data(): ComponentData {
    const value = this.modelValue;
    return { value, validation_message: undefined };
  },
  methods: {
    validate() {
      this.validation_message = undefined;

      for (let name in this.$props.validators) {
        this.validation_message = validators[name](
          this.value,
          this.$props.validators[name]
        );
        if (this.validation_message)
          this.$emit("updateValidation", this.name, false);
      }
      this.$emit("updateValidation", this.name, true);
    },
  },
  props: {
    modelValue: Number,
    name: String,
    label: String,
    readonly: Boolean,
    maxlength: Number,
    minlength: Number,
    not_editable: Boolean,
    manual_focus: Boolean,
    format: String,
    validators: Object,
    validation: Object,
  },
  emits: ["update:modelValue", "updateValidation"],
  watch: {
    value(n) {
      this.$emit("update:modelValue", n);
      this.validate();
    },
    modelValue(n) {
      this.value = n;
    },
    validation(value) {
      this.validation_message = value.message;
    },
  },
});
